import { render, staticRenderFns } from "./DetalhesRegional.vue?vue&type=template&id=7976a1d4&scoped=true&lang=pug"
import script from "./DetalhesRegional.vue?vue&type=script&lang=js"
export * from "./DetalhesRegional.vue?vue&type=script&lang=js"
import style0 from "./DetalhesRegional.vue?vue&type=style&index=0&id=7976a1d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7976a1d4",
  null
  
)

export default component.exports